package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_01_26_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes who recently stepped through the portal, received provisions and guidance from Sergeant Jayle, and started on their 6 day journey to Zedj. Caper drives the cart because the horse is named “Flower.” They travel and old route and don’t see many travelers just some small animals like squirrels — nothing larger than a cat. Around 6pm they find a camp spot.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("During watch #4, the heroes hear 3 individuals speaking in common in the south east. “But Daveed, that doesn’t make sense.” 3 humans approach their camp. Our heroes quickly see through their disguise, they are Slaad, magical evil Toads. The problem of the trespassers is resolved by a hearty helping of violence.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Annette loots a piece of paper with some unknown language from one of the Daveeds.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper and Falorn inform the others about their vision of Entor. Our heroes apparently need:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A small purple gem, the “compound eye”")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A metal rod, the “gray rod” - a 1/4” thick rod")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes apparently can’t get to the next shield piece location until they get these things.")
    }
}
